/* global axios */
import ApiClient from './ApiClient';

class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true, apiVersion: 'v2' });
  }

  flows(botId) {
    return axios.get(`${this.url}/${botId}/flows`);
  }

  flow(botId, flowId) {
    return axios.get(`${this.url}/${botId}/flows/${flowId}`);
  }

  saveFlow(botId, payload) {
    return axios.post(`${this.url}/${botId}/flows`, { flow: payload });
  }

  updateFlow(botId, flowId, payload) {
    return axios.patch(`${this.url}/${botId}/flows/${flowId}`, {
      flow: payload,
    });
  }

  publishFlow(botId, flowId, notes) {
    return axios.post(`${this.url}/${botId}/flows/${flowId}/publish`, {
      notes,
    });
  }

  testRun(botId, payload) {
    const body = Array.isArray(payload) ? { transcript: payload } : payload;
    return axios.post(`${this.url}/${botId}/test_run`, body);
  }

  toolCatalog() {
    return axios.get(`${this.url}/tool_catalog`);
  }

  variables() {
    return axios.get(`${this.url}/variables`);
  }
}

export default new AgentBotsAPI();
